// removed by extract-text-webpack-plugin
module.exports = {"projectTablesection":"projectTablesection__2KEfi","breadCrumbWrapper":"breadCrumbWrapper__2sp_7","desktopTable":"desktopTable__1OCeP","mapWrapper":"mapWrapper__39OGe","wrapper":"wrapper__ueLiz","galleryWrapper":"galleryWrapper__3qXEv","gallerOuter":"gallerOuter__3blMf","galleryHeading":"galleryHeading__1eIl_","deliveryModelComponentWrapper":"deliveryModelComponentWrapper__2pLwl","deliveryModelWrapper":"deliveryModelWrapper__133AY","deliveryModelHeading":"deliveryModelHeading__RESrb","deliveryModelProjectWrapper":"deliveryModelProjectWrapper__WYhTi"};


//////////////////
// WEBPACK FOOTER
// ./routes/projectDetails/style.css
// module id = pWm/
// module chunks = 2